export default __webpack_public_path__ + "static/media/group-3-img1.0eca2035.png";